import Api from './Api';

let schemeNo = '' // 活动方案
let taskNo = '' // 任务编号
let modelId = ''
let templateId = ''
let shareActionNo = ''
let rankTaskNo = '' // 分享排行榜任务编号

if (Api.isLan) { // 开发 || 测试
	if (Api.isLan === 'dev') { // 开发环境
		schemeNo = '992fe9282b4847bc972c15e7c336d333'
		taskNo = 'TAS_DYIHNVVS'
		modelId = '25'
		templateId = '59'
		shareActionNo = 'ACT_BTKGIUVY'
		rankTaskNo = ''
	} else { // 测试环境
		schemeNo = 'ac290f5d4997460393efc052cfcb91ed'
		taskNo = 'TAS_ZKTBGZNW'
		modelId = '30'
		templateId = '85'
		shareActionNo = 'ACT_XQSPGPQB'
		rankTaskNo = 'ACT_WUNKGLLC'
	}
} else {
	schemeNo = '5e0957054f7647a7a7f0583c9bf941b5'
	taskNo = 'TAS_OJJSZXGZ'
	modelId = '29'
	templateId = '93'
	shareActionNo = 'ACT_ZTVKIRSY'
	rankTaskNo = 'ACT_VYOBKPWF'
}

export default {
	template: {},
	appId: 'wxfb51d68edffc90e2', // 测试wxfb51d68edffc90e2 便民服务：wxdb66d51599b705f7
	clientName: '', // 客户端名称
	clientId: '538', // 客户端ID 测试538 正式511
	channelId: 'ZGYH_YFCJH', // 渠道ID
	clientVersionNo: '1',
	loginInfo: null, // 用户信息
	authType: 'FZS', // 优惠券授权类型
	authCode: '', // 优惠券授权码
	userId: '', // 默认用户id
	appKey: '00001',
	appSecret: 'AWSDCS',
	messageInfo: { // 登录所需短信配置
		registerFrom: 'ZGYH_YFCJH', // 注册来源 以下三个参数皆为一键登录所用参数
		modelId: modelId, // 测试30 正式29
		templateId: templateId, //测试83 正式86
	},
	schemeNo: schemeNo, // 活动方案
	taskNo: taskNo, // 任务编号
	shareActionNo: shareActionNo, // 分享行为
	rankTaskNo: rankTaskNo, // 分享排行榜任务编号
	cipherText: '',
	bocOpenId: '', // 中行的openId
	fzsOpenId: '', // 蜂助手的openId
	fzsAuthorizeDev: {
		index: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdb66d51599b705f7&redirect_uri=https%3A%2F%2Fpay.phone580.com%2Fwechat-testapi%2Fauthorize%3FtargetUri%3Dhttp%253A%252F%252F10.20.10.14%253A6688%252F%2523%252Findex%253Ffzs%253Dtrue%26appid%3Dwxdb66d51599b705f7%26scope%3Dsnsapi_base%26isRequireUserinfo%3D-1%26isAutoLogin%3D0%26isFzsLoginPage%3D0%26loginVersion%3D1&response_type=code&scope=snsapi_base&state=oxnAIQ1578381760534#wechat_redirect',
		reward: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1ec6de6c990ae645&redirect_uri=https%3A%2F%2Fopenapi.phone580.com%2FwechatApi%2Fauthorize%3FtargetUri%3Dhttp%253A%252F%252F10.20.10.14%253A6688%252F%2523%252Freward%253Ffzs%253Dtrue%26appid%3Dwx1ec6de6c990ae645%26scope%3Dsnsapi_base%26isRequireUserinfo%3D-1%26isAutoLogin%3D0%26isFzsLoginPage%3D0%26loginVersion%3D1&response_type=code&scope=snsapi_base&state=EprfMr1574673085275#wechat_redirect'
	},
	fzsAuthorizeTest: {
		index: '',
		reward: ''
	},
	fzsAuthorizeGray: {
		index: '',
		reward: ''
	},
	fzsAuthorizeUrl: {
		index: '',
		reward: ''
	},
	cacheOperate: '', // 缓存起来的操作 页面mounted的时候需要立刻调用，使用完后清除
	shareOpenId: '', // 分享人的openid
	shareUserId: '', // 分享人的userId
	cipherTextNew: '', // 缩短的用户加密串
	weChatServerInject: false, // 判断微信服务是否注入成功
	selectMouse: 0, // 当前选中的老鼠
	bocUserLogin: false, // 中行用户是否登录
	goFzsAuthorize: false, // 可以不用授权拉
}
